import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "stack",
        "sidebar",
        "backdrop",
        "mainCard",
        "positionFeedback",
        "slotFeedback",
        "openButtons",
    ]

    async openNested(event) {
        event.preventDefault()

        const button = event.currentTarget
        const kind = button.dataset.kind
        const targetSelect = button.dataset.targetSelect
        if (!kind || !targetSelect) return

        this.openSidebarUI()

        this.disableOpenButtons(true)

        const url = this.nestedUrl(kind, targetSelect)
        if (!url) return

        const response = await fetch(url, { headers: { Accept: "text/html" } })
        if (!response.ok) return

        const html = await response.text()


        this.stackTarget.insertAdjacentHTML("afterbegin", html)

        this.focusFirstField()
    }

    nestedUrl(kind, targetSelect) {
        const qs = `nested=1&target_select=${encodeURIComponent(targetSelect)}`
        if (kind === "position") return `/fr/backoffice/volunteer_positions/new?${qs}`
        if (kind === "slot") return `/fr/backoffice/volunteer_slots/new?${qs}`
        if (kind === "category") return `/fr/backoffice/volunteer_categories/new?${qs}`
        if (kind === "spot") return `/fr/backoffice/volunteer_spots/new?${qs}`
        if (kind === "area") return `/fr/backoffice/volunteer_areas/new?${qs}`
        if (kind === "event_day")  return `/fr/backoffice/event_days/new?${qs}`
        if (kind === "slot_range") return `/fr/backoffice/volunteer_slot_ranges/new?${qs}`
        return null
    }

    async submitNested(event) {
        event.preventDefault()

        const form = event.currentTarget
        const panel = form.closest("[data-nested-panel]")
        if (!panel) return

        const url = form.action
        const method = (form.method || "post").toUpperCase()
        const targetSelectId = form.dataset.targetSelect
        if (!targetSelectId) return

        const response = await fetch(url, {
            method,
            headers: { Accept: "application/json" },
            body: new FormData(form),
        })

        if (response.status === 422) {
            const data = await response.json()
            if (data?.html) {
                panel.outerHTML = data.html
                this.focusFirstField()
            }
            return
        }

        if (!response.ok) return

        const data = await response.json()
        if (!data?.id) return

        this.addOptionToSelect(targetSelectId, data.id, data.label)

        this.showFeedback(targetSelectId)

        panel.remove()

        if (!this.hasAnyPanelOpen()) {
            this.closeSidebar()
            return
        }

        this.focusFirstField()
    }
    closeNested(event) {
        event.preventDefault()

        const panel = event.currentTarget.closest("[data-nested-panel]")
        if (panel) panel.remove()
        
        if (!this.hasAnyPanelOpen()) {
            this.closeSidebar()
            return
        }

        this.focusFirstField()
    }

    closeSidebar(event) {
        if (event) event.preventDefault()

        this.stackTarget.innerHTML = ""
        this.sidebarTarget.classList.remove("is-open")
        this.backdropTarget.classList.add("d-none")
        this.mainCardTarget.classList.remove("mission-main--disabled")
        this.sidebarTarget.setAttribute("aria-hidden", "true")

        this.disableOpenButtons(false)
    }

    openSidebarUI() {
        this.sidebarTarget.classList.add("is-open")
        this.backdropTarget.classList.remove("d-none")
        this.mainCardTarget.classList.add("mission-main--disabled")
        this.sidebarTarget.setAttribute("aria-hidden", "false")
    }

    disableOpenButtons(disabled) {
        if (!this.hasOpenButtonsTarget) return
        this.openButtonsTargets.forEach((btn) => {
            btn.disabled = disabled
            btn.classList.toggle("disabled", disabled)
        })
    }

    hasAnyPanelOpen() {
        return !!this.stackTarget.querySelector("[data-nested-panel]")
    }

    focusFirstField() {
        const top = this.stackTarget.querySelector("[data-nested-panel]")
        if (!top) return
        const field = top.querySelector("input:not([type='hidden']), select, textarea")
        if (field) field.focus()
    }

    addOptionToSelect(selectId, id, label) {
        const select = document.getElementById(selectId)
        if (!select) return

        const value = String(id)
        const exists = Array.from(select.options).some((opt) => opt.value === value)
        if (!exists) select.add(new Option(label, value))

        select.value = value
        select.dispatchEvent(new Event("change", { bubbles: true }))
    }

    showFeedback(selectId) {
        let feedback = null

        if (selectId === "mission_volunteer_position_id" && this.hasPositionFeedbackTarget) {
            feedback = this.positionFeedbackTarget
            feedback.textContent = "✓ Position créée et sélectionnée"
        }

        if (selectId === "mission_volunteer_slot_id" && this.hasSlotFeedbackTarget) {
            feedback = this.slotFeedbackTarget
            feedback.textContent = "✓ Créneau créé et sélectionné"
        }

        if (!feedback) return
        feedback.classList.remove("d-none")
        setTimeout(() => feedback.classList.add("d-none"), 2500)
    }
}